<template>
    <div class="naef-bg" id="login">
        <main class="flex flex-1 flex-col items-center pb-10 pt-[126px] md:pt-[180px]">
            <div class="naef-carte p-9">
                <div class="sm:mx-auto sm:w-full sm:max-w-md">
                    <img
                        class="mx-auto h-[52px] w-auto"
                        src="@/assets/imgs/naef-projets-neufs-logo.svg"
                        alt="Naef Projets Neufs"
                    />
                    <img
                        class="mx-auto mt-4 h-[34px] w-auto"
                        src="@/assets/imgs/naef-logo.svg"
                        alt="e-promotion"
                    />
                    <h2
                        class="mt-8 text-center font-display font-semibold text-ds-display text-nuit-noire"
                    >Modification du mot de passe</h2>
                </div>
                <form action="#" method="POST" class="mt-8" @submit.prevent="reset">
                    <div>
                        <label
                            for="email"
                            class="block text-ds-body text-nuit-noire"
                        >Email</label>
                        <div class="mt-1">
                            <input
                                v-model="email"
                                id="email"
                                type="email"
                                required
                                class="form-input-ds"
                            />
                        </div>
                    </div>
                    <div class="mt-4">
                        <label
                            for="password"
                            class="block text-ds-body text-nuit-noire"
                        >Mot de passe</label>
                        <div class="mt-1">
                            <input
                                v-model="password"
                                id="password"
                                type="password"
                                required
                                class="form-input-ds"
                            />
                        </div>
                    </div>

                    <div class="mt-4">
                        <label
                            for="passwordConfirmation"
                            class="block text-ds-body text-nuit-noire"
                        >Confirmation du mot de passe</label>
                        <div class="mt-1">
                            <input
                                v-model="passwordConfirmation"
                                id="passwordConfirmation"
                                type="password"
                                required
                                class="form-input-ds"
                            />
                        </div>
                    </div>

                    <div class="mt-6">
                        <span class="block w-full">
                            <button
                                type="submit"
                                class="btn-ds btn-ds--primary w-full"
                            >Modifier mon mot de passe</button>
                        </span>
                    </div>
                </form>
            </div>
        </main>

        <mentions-legales />
    </div>
</template>

<script>
import Cookies from "js-cookie";

import auth from "@/api/auth";
import MentionsLegales from "@/components/global/MentionsLegales";

export default {
    components: { MentionsLegales },
    data() {
        return {
            email: "",
            password: "",
            passwordConfirmation: ""
        };
    },

    beforeMount() {
        Cookies.remove("token");
        this.token = this.$route.params.token;

        if (!this.token) {
            this.$router.push({ name: "reset-password" });
        } else {
            auth.checkPasswordToken(this.token)
                .then(() => {
                    // token is ok
                })
                .catch(error => {
                    this.$toast.open({
                        type: "error",
                        message: error.response.data.error
                    });
                });
        }
    },

    methods: {
        reset() {
            if (this.password !== this.passwordConfirmation) {
                this.$toast.open({
                    type: "error",
                    message: "Les mots de passe doivent être identiques"
                });
            } else {
                const body = {
                    email: this.email,
                    password: this.password,
                    token: this.token
                };
                auth.resetPassword(body)
                    .then(() => {
                        this.$toast.open({
                            type: "success",
                            message: "Mot de passe bien modifié"
                        });
                        this.$router.push({ name: "login" });
                    })
                    .catch(() => {
                        this.$toast.open({
                            type: "error",
                            message: "Une erreur est survenue"
                        });
                    });
            }
        }
    }
};
</script>
